<template>
  <div>
    <vue-content-loading :width="300" :height="7" class="my-2">
      <rect x="0" y="0" rx="2" ry="2" width="500" height="7" />
    </vue-content-loading>
    <b-row>
      <b-col sm="12">
        <hr />
      </b-col>
    </b-row>
    <vue-content-loading :width="300" :height="7" class="my-2">
      <rect x="0" y="0" rx="2" ry="2" width="500" height="7" />
    </vue-content-loading>
    <vue-content-loading :width="300" :height="50" class="mb-2" v-for="(n, vcl) in 3" :key="`vlc-${vcl}`">
      <rect x="0" y="0" rx="2" ry="2" width="500" height="100" />
    </vue-content-loading>
  </div>
</template>

<script>
// @ is an alias to /src
import { VueContentLoading } from "vue-content-loading"
export default {
  name: "loadingPanelHotel",
  components: {
    VueContentLoading
  },
  mounted() {},
  beforeCreate() {},
  methods: {}
}
</script>
